import { Routes } from '@angular/router';
import { HomeComponent } from './views/home/home.component';
import { CompensacionDeudasExcedentesComponent } from './views/compensacion-deudas-excedentes/compensacion-deudas-excedentes.component';

export const routes: Routes = [
    { path:'', component:HomeComponent },
    { path:':qs', component:HomeComponent, runGuardsAndResolvers: 'paramsOrQueryParamsChange' },
    { path:'compensacion-deudas-excedentes/:qs', component: CompensacionDeudasExcedentesComponent, runGuardsAndResolvers: 'paramsOrQueryParamsChange' },

    // { path:'notificacion-firma-mandato', component: NotificacionFirmaMandatoComponent },
    
    //{ path: '**', redirectTo: 'restitucion', pathMatch: 'full' }
];
